import React from "react";

const LastestPosts = ({ posts = [] }) => {
  // Function to format the date to "DD.MM.YYYY"
  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0"); // Ensure two-digit day
    const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Ensure two-digit month
    const year = d.getFullYear();

    return `${day}.${month}.${year}`; // Return formatted date
  };

  // Safeguard for empty posts array
  if (!posts.length) {
    return (
      <div className="container mx-auto px-4 py-8">
        <p className="text-gray-600 text-center">
          No posts available at the moment.
        </p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header Section */}
      <div className="flex justify-between items-center border-b pb-2 mb-6 mx-10">
        <a
          href="/blog/latest/"
          className="text-xl font-bold text-gray-800 hover:text-blue-600"
        >
          Latest Posts
        </a>
        <a
          href="/blog/latest/"
          className="text-sm text-blue-500 hover:underline"
        >
          See all
        </a>
      </div>

      {/* First Post Layout (Image Left, Info Right) */}
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-6 flex mx-10 transform transition-all hover:scale-105 hover:shadow-2xl hover:bg-gray-50">
        <a href={posts[0]?.link} className="w-1/2">
          <img
            src={
              posts[0]?.featuredImage
                ? `${process.env.REACT_APP_DO_SPACES_URL}${posts[0].featuredImage}`
                : "/placeholder.jpg"
            }
            alt={posts[0]?.title || "Post image"}
            className="w-full h-96 object-cover transform transition-all hover:scale-110"
          />
        </a>
        <div className="w-1/2 p-6">
          <div className="text-gray-500 text-sm flex items-center space-x-2">
            <span>{posts[0]?.author || "Unknown Author"}</span>
            <span>-</span>
            <span>
              {formatDate(posts[0]?.date) || "No date available"}
            </span>{" "}
            {/* Formatted date */}
            <span>-</span>
            <span>{posts[0]?.readMins || "N/A"} mins read</span>
          </div>
          <a href={posts[0]?.link} className="block mt-2">
            <h3 className="text-5xl font-bold text-gray-800 hover:text-blue-600">
              {posts[0]?.title || "Untitled Post"}
            </h3>
          </a>
          <p className="text-gray-600 mt-4 text-lg">
            {posts[0]?.excerpt || "No excerpt available."}
          </p>
        </div>
      </div>

      {/* Other Posts Grid Layout (Image on top, content below) */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mx-10">
        {posts.slice(1).map((post, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-lg overflow-hidden mb-6 transform transition-all hover:scale-105 hover:shadow-2xl hover:bg-gray-50"
          >
            <a href={post?.link}>
              <img
                src={
                  post?.featuredImage
                    ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`
                    : "/placeholder.jpg"
                }
                alt={post?.title || "Post image"}
                className="w-full h-64 object-cover transform transition-all hover:scale-110"
              />
            </a>
            <div className="p-6">
              <div className="text-gray-500 text-sm flex items-center space-x-2">
                <span>{post?.author || "Unknown Author"}</span>
                <span>-</span>
                <span>
                  {formatDate(post?.date) || "No date available"}
                </span>{" "}
                {/* Formatted date */}
                <span>-</span>
                <span>{post?.readMins || "N/A"} mins read</span>
              </div>
              <a href={post?.link} className="block mt-2">
                <h3 className="text-lg font-bold text-gray-800 hover:text-blue-600">
                  {post?.title || "Untitled Post"}
                </h3>
              </a>
              <p className="text-gray-600 mt-2">
                {post?.excerpt || "No excerpt available."}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LastestPosts;
